
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 20.9a.9.9 0 100-1.8.9.9 0 000 1.8zM16.2 22.1c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9zM21.6 24c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9zM43.5 23.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-.9.4-.9.9.4.9.9.9z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53.3 31.9c0 1-.4 1.9-1 2.6.9.7 1.5 1.8 1.5 2.9 0 2-1.5 3.6-3.4 3.9-.5 3.1-3.2 5.5-6.4 5.5H15.3c-3.3 0-6-2.4-6.5-5.6-1.6-.4-2.8-1.9-2.8-3.7 0-1.3.6-2.4 1.6-3.1-.4-.6-.6-1.3-.6-2v-1.1c0-1.3.7-2.4 1.8-3v-1.9c0-6.8 5.5-12.4 12.4-12.4h16.9c6.8 0 12.4 5.6 12.4 12.5v1.7c1.6.4 2.8 1.9 2.8 3.7zm-2.2 0c0-.9-.6-1.6-1.5-1.7-.1 0-.1 0-.2.1H36.2c-.7.1-1.3.8-1.3 1.6 0 .9.8 1.7 1.7 1.7h12.8c.9 0 1.7-.8 1.7-1.7zM21.2 16.2c-5.6 0-10.2 4.6-10.2 10.2V28h37.3v-1.6c0-5.6-4.6-10.2-10.2-10.2H21.2zm.3 17.4h2.2c.6 0 1.1.5 1.1 1.1v1.6c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-1.6c0-.6.5-1.1 1.1-1.1h2.7c.7 0 1.3-.6 1.3-1.3v-.8c0-.7-.5-1.2-1.1-1.3h-9.4c-.5.2-.7.8-.7 1.3v2.1zm0 5.6h2.6c-.9-.7-1.5-1.8-1.5-3v-.4h-1.1v3.4zm-11.4-9c-.5.1-.9.5-.9 1.1h-.1v1.1c0 .7.6 1.2 1.2 1.2h5c.6 0 1.1.5 1.1 1.1v5.6c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-9c0-.5-.4-1-.9-1.1h-8.2zm-1.9 7.3c0 .9.8 1.7 1.7 1.7h4.3v-3.4H9.9c-.9 0-1.7.8-1.7 1.7zm7.1 7.1H44c2 0 3.6-1.4 4.1-3.2H21.2c-.4 1.4-1.8 2.5-3.4 2.5-1.6 0-2.9-1.1-3.4-2.5h-3.3c.5 1.8 2.2 3.2 4.2 3.2zm34.6-5.4c.9 0 1.7-.7 1.7-1.6 0-.9-.8-1.7-1.7-1.7H29.8v.4c0 1.2-.6 2.2-1.5 2.9h21.6z"}})])
          )
        }
      }
    